import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/yuze-dolgu-yapan-doktorlar-hangi-brans-yetkilidir-nasil-secim-yapilmali/page.tsx");
